export enum DanceSchoolRoomTypeEnum {
  BASE = 'BASE',
  COMPOSITE = 'COMPOSITE',
}
